module.exports = __webpack_public_path__ + "static/img/hsmd.59561366.png";